import EdfiReaderNode from './types/edfi-reader';
import EdfiWriterNode from './types/edfi-writer';

export const edfiNodes = {
  edfiReader: EdfiReaderNode,
  edfiWriter: EdfiWriterNode,
};
